import pk from '../package.json'

const TEST_HOSTS = [
  'localhost',
  'emapachedev1a.luxgroup.net:7129',
  'memberdev1.eyemedvisioncare.com',
  'kbygdev1.eyemedvisioncare.com',
  'emapachefet01.luxgroup.net:7129',
  'memberashuat.eyemedvisioncare.com',
  'kbygashuat.eyemedvisioncare.com',
  'kbygdev2.eyemedvisioncare.com'
]

const HOSTNAME = window.location.origin
export const isTestContentLocation = TEST_HOSTS.some(host => HOSTNAME.includes(host))

const buildApiUrl = () => {
  //temporarily commented this code
  const API_URL_ENV_FILE = (import.meta.env.VITE_API_URL as string).replace(/\/?$/, '')
  const isAbsolutePath = (API_URL_ENV_FILE.match(/\//g) || []).length !== 1
  return isAbsolutePath ? API_URL_ENV_FILE : `${HOSTNAME}${API_URL_ENV_FILE}` as string
}
const API_URL = buildApiUrl()
const CONTENT_BASE_URL = isTestContentLocation ? 'https://content.eyemedvisioncare.com/contentMEMTEST' : 'https://content.eyemedvisioncare.com/contentMEM'
const ANALYTICS_SCRIPT = isTestContentLocation ? 'https://assets.adobedtm.com/20117d61d4d3/4f58af6d7ced/launch-21f59086e6ea-staging.min.js' : 'https://assets.adobedtm.com/20117d61d4d3/4f58af6d7ced/launch-140e11a39393.min.js'

const config = {
  VERSION: pk.version,
  API_URL,
  CONTENT_BASE_URL,
  ANALYTICS_SCRIPT,
  TEST_HOSTS
}

export default config
